import { useQuery } from '@tanstack/react-query';
import { fetchAttachmentTemplatesForImport } from '@/api/orders';

function buildAttachmentTemplatesQs(): string {
  return new URLSearchParams({
    templateType: 'PRODUCT_BACKWARD',
    count: '100',
  }).toString();
}

export const attachmentTemplatesQueryOptions = {
  queryKey: ['attachmentTemplatesForImport'] as const,
  queryFn: () =>
    fetchAttachmentTemplatesForImport(buildAttachmentTemplatesQs()),
  staleTime: 5 * 60 * 1000,
};

export function useAttachmentTemplatesForImport() {
  return useQuery(attachmentTemplatesQueryOptions);
}
